<template>
    <v-row>
        <div class="col-md-12 home-box">
            <Breadcrumbs :title="'Goods Return Notes'"></Breadcrumbs>
            <GrnList></GrnList>

        </div>
    </v-row>
    
</template>



<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import GrnList from "@/components/GoodsReturn/GoodsReturnList.vue";
export default {
    name: 'grn',
    components:{
        Breadcrumbs,
        GrnList

    }
}
</script>